/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import TreeNode from "App/utils/globe/chunk_lod/tree/node";
import {vec3} from "gl-matrix";

export default
class SyncRequest {
    private uid: string;
    public node: TreeNode;
    public metadata: { col: number; nofTextureLODS: number; nc: number; level: number; heights: any[]; bbox: { min: vec3; max: vec3 }; widths: any[]; nofFaces: number; row: number; nofPoints: number };
    public type: string;
    public positions: ArrayBuffer;
    public normals: ArrayBuffer;
    public texCoords: ArrayBuffer;
    public layers: null | any;
    public surfaceStyles: ArrayBuffer;
    public indices: ArrayBuffer;
    public textureData: ArrayBuffer;

    constructor(aUID: string, aNode: TreeNode, aType: string, aMetadata: any, aAttributes: any, aIndices: ArrayBuffer, aTextureData: ArrayBuffer) {
        this.uid = aUID;
        this.node = aNode;
        this.metadata = aMetadata;
        this.type = aType;
        this.positions = aAttributes.positions;
        this.normals = aAttributes.normals;
        this.texCoords = aAttributes.texcoords;
        this.layers = aAttributes.layers;
        this.surfaceStyles = aAttributes.surfacestyles;
        this.indices = aIndices;
        this.textureData = aTextureData;
    }

    public getUID(): string {
        return this.uid;
    }

    public getSize(): number {
        return (this.positions.byteLength + this.normals.byteLength + this.texCoords.byteLength + this.surfaceStyles.byteLength + this.indices.byteLength + (this.textureData ? this.textureData.byteLength : 0));
    }
}
